import React from 'react'
import '../styles/main.css';
import { Link } from 'react-router-dom'
import { MdOutlineEmail, MdOutlineCall } from 'react-icons/md'

export default function Contact({ref}) {
  return (
    <section className="contact" ref={ref} data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out-quad">
      <h2>
        <span className='beautify'>04. </span>Contact me
      </h2>
      <p>
        Questions or opportunities? I'm here to connect and collaborate!
      </p>
      <ul className='contact-info'>
        <li>
          <MdOutlineEmail size={25} color='#36454F'/>
          <h4><Link to="mailto:rishabh0739@gmail.com">rishabh0739@gmail.com</Link></h4>
        </li>
      </ul>
    </section>
  )
}
